import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import isSameDay from 'date-fns/isSameDay';
import addDays from 'date-fns/addDays';
import { KLEINESCHEIDEGG, EIGERGLETSCHER, FIRST, BUSSALP, BIRG, ALLMENDHUBEL, SCHILTHORN, MUERREN, SCHRECKFELD, FAULHORN } from '~/config/settings/settingsWeatherStations';
import { API_URL_WEATHER } from '~/config/settings/settingsApi';

export default {

    /**
     *
     */
    async loadWeatherStationData() {
        try {
            const apiData = await axios.get(API_URL_WEATHER);
            const stations = apiData.data.data;

            // Remove all forecasts except today and tomorrow, to remove unnecessary data
            stations.forEach((station) => {
                station.forecasts = station.forecasts.filter(forecast => isSameDay(new Date(station.currentHour.timestamp), new Date(forecast.timestamp))
                || isSameDay(addDays(new Date(station.currentHour.timestamp), 1), new Date(forecast.timestamp)));
            });

            // Currently there is no Eigergletscher Station, so we take values from Kleine Scheidegg and adjust them
            const stationEigergletscher = cloneDeep(stations.find(item => item.location.id === KLEINESCHEIDEGG));

            stationEigergletscher.location.id = EIGERGLETSCHER;
            stationEigergletscher.location.name = 'Eigergletscher';
            stationEigergletscher.location.elevation = 2320;

            // Simply take Kleine Scheidegg temperatures and subtract 2 degrees. Lol very accurate
            stationEigergletscher.currentHour.temperatureInCelsius.value -= 2;
            stationEigergletscher.currentHour.temperatureInCelsius.apparent -= 2;

            stationEigergletscher.forecasts.forEach((item) => {
                item.temperatureInCelsius.value -= 2;
                item.temperatureInCelsius.apparent -= 2;
            });

            stations.push(stationEigergletscher);

            // Currently there is no Schreckfeld Station, so we take values from First and adjust them
            const stationSchreckfeld = cloneDeep(stations.find(item => item.location.id === FIRST));
            stationSchreckfeld.location.id = SCHRECKFELD;
            stationSchreckfeld.location.name = 'Schreckfeld';
            stationSchreckfeld.location.elevation = 1955;
            stations.push(stationSchreckfeld);

            // Currently there is no Faulhorn Station, so we take values from First and adjust them
            const stationFaulhorn = cloneDeep(stations.find(item => item.location.id === FIRST));
            stationFaulhorn.location.id = FAULHORN;
            stationFaulhorn.location.name = 'Faulhorn';
            stationFaulhorn.location.elevation = 2681;

            stationFaulhorn.forecasts.forEach((item) => {
                item.temperatureInCelsius.value -= 2;
                item.temperatureInCelsius.apparent -= 2;
            });

            stations.push(stationFaulhorn);

            // Currently there is no Bussalp Station, so we take values from First and adjust them
            const stationBussalp = cloneDeep(stations.find(item => item.location.id === FIRST));
            stationBussalp.location.id = BUSSALP;
            stationBussalp.location.name = 'Bussalp';
            stationBussalp.location.elevation = 1797;
            stations.push(stationBussalp);

            // Currently there is no Allmendhubel Station, so we take values from Mürren and adjust them
            const stationAllmendhubel = cloneDeep(stations.find(item => item.location.id === MUERREN));
            if (stationAllmendhubel) {
                stationAllmendhubel.location.id = ALLMENDHUBEL;
                stationAllmendhubel.location.name = 'Allmendhubel';
                stationAllmendhubel.location.elevation = 1932;

                // Simply take Mürren temperatures and add 2 degrees. Lol very accurate
                stationAllmendhubel.currentHour.temperatureInCelsius.value -= 2;
                stationAllmendhubel.currentHour.temperatureInCelsius.apparent -= 2;

                stationAllmendhubel.forecasts.forEach((item) => {
                    item.temperatureInCelsius.value -= 2;
                    item.temperatureInCelsius.apparent -= 2;
                });
                stations.push(stationAllmendhubel);
            }

            // Currently there is no Birg Station, so we take values from Schilthorn and adjust them
            const stationBirg = cloneDeep(stations.find(item => item.location.id === SCHILTHORN));
            if (stationBirg) {
                stationBirg.location.id = BIRG;
                stationBirg.location.name = 'Birg';
                stationBirg.location.elevation = 2676;
                stations.push(stationBirg);
            }

            return {
                error: false,
                data: stations,
            };

        } catch (error) {
            console.error('Error fetching weather API data', error);
            return {
                error: error.message,
                data: null,
            };
        }
    },
};
